/**
 * Utilitaires d'envoi WhatsApp / SMS avec garde-fous :
 *   - validation du numéro (jamais d'envoi vers un destinataire manquant/invalide)
 *   - ouverture RÉELLE du canal
 *   - confirmation manuelle avant de passer au statut « envoyé »
 * Aucun statut n'avance si le canal ne s'ouvre pas ou si l'admin n'a pas confirmé.
 */

export function normalizePhone(phone) {
  return (phone || "").replace(/[^\d+]/g, "");
}

export function phoneValid(phone) {
  const digits = (phone || "").replace(/\D/g, "");
  return digits.length >= 8 && digits.length <= 15;
}

/**
 * Ouvre WhatsApp ou SMS avec message pré-rempli, puis demande confirmation.
 * Retourne true si l'admin confirme l'envoi (→ statut « envoyé »), false sinon.
 * Lève une erreur "no-phone" si le numéro est manquant/invalide.
 */
export function sendAndConfirm({ channel, message, phone }) {
  if (!phoneValid(phone)) {
    const err = new Error("no-phone");
    err.code = "no-phone";
    throw err;
  }
  const clean = normalizePhone(phone);
  const wa = clean.replace(/^\+?/, "");
  const url =
    channel === "sms"
      ? `sms:${clean}?body=${encodeURIComponent(message)}`
      : `https://wa.me/${wa}?text=${encodeURIComponent(message)}`;

  const win = window.open(url, "_blank", "noopener,noreferrer");
  if (!win && channel === "sms") {
    // sms: ne s'ouvre pas toujours via window.open → bascule en navigation directe
    window.location.href = url;
  }

  const channelLabel = channel === "sms" ? "SMS" : "WhatsApp";
  return window.confirm(
    `Avez-vous bien envoyé le message ${channelLabel} au voyageur ?\n\n• OK → marquer « Formulaire envoyé »\n• Annuler → laisser « À envoyer »`
  );
}
